import baseURL from '../modules/api/url'

export const nutritionImport = {
    nutritionBooleanFields: [
        'Crustacean Shellfish',
        'Eggs',
        'Fish',
        'Gluten Free',
        'Milk',
        'Organic',
        'Sesame',
        'Peanut',
        'Soy',
        'Tree Nut',
        'Wheat',
    ],

    nutritionDataFields: [
        'Added Sugars',
        'Caffeine',
        'Calcium',
        'Calories',
        'Calories from Fat',
        'Cholesterol',
        'Dietary Fiber',
        'Erythritol',
        'InsolubleFiber',
        'Iron',
        'Magnesium',
        'Monounsaturated Fat',
        'Niacin Vit-B3',
        'Other Carbohydrate',
        'Pantothenic Acid',
        'Phosphorus',
        'Polyunsaturated Fat',
        'Potassium',
        'Protein',
        'Riboflavin (B2)',
        'Saturated Fat',
        'Sodium',
        'Sugar Alcohol',
        'Thiamin (B1)',
        'Total Carbohydrate',
        'Total Fat',
        'Total Sugars',
        'Trans Fat',
        'Vitamin A',
        'Vitamin B12',
        'Vitamin B6',
        'Vitamin C',
        'Vitamin D',
        'Vitamin E',
    ],
    nutrientsImportsUrlPath: `${baseURL.SEVEN_NOW_CORE_API_URL}/catalog/products/updateProductsNutritions`,
}
